import React, { FC, useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import {
    MarkDownIsland,
    MessageBarData,
    MarkDownIslandType,
    Language,
} from '@eta/components';
import { connect, ConnectedProps } from 'react-redux';
import { authService } from '../../Security/Security';
import { ServiceCreator } from '../../ContentManagement/Service/client';
import { MarkDownType } from '../../common/config/constants';
import { ReduxState } from '../../common/reducers';

export interface MarkDownProps {
    Type: string;
}
const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const MarkDown: FC<PropsFromRedux & MarkDownProps> = (
    props: PropsFromRedux & MarkDownProps
) => {
    const { Type: messageTypeProps, currentLanguage: propsCurrentLanguage } =
        props;
    const [messageBarData, setMessageBarData] = useState<MessageBarData>();
    const [showMessageType, setshowMessageType] =
        useState<string>(messageTypeProps);

    const setShowMessege = (Type: string) => {
        switch (Type) {
            case MarkDownType.Informative:
                setshowMessageType(MarkDownIslandType.Informative);
                break;
            case MarkDownType.Important:
                setshowMessageType(MarkDownIslandType.Important);
                break;
            case MarkDownType.Terms:
            case MarkDownType.Full:
            case MarkDownType.RegistrationPrivacy:
                setshowMessageType(MarkDownIslandType.Full);
                break;
            default:
                break;
        }
    };

    const handleMessageBarData = async (code: string, lang: Language) => {
        try {
            const isArLang = lang.langIso4.includes('ar');
            const currLang = isArLang ? 'ar' : 'en';
            const client = ServiceCreator.getContentManagementClient(true);
            const response = await client.getContentByCode(code, currLang);
            const content = isArLang
                ? response.contentSecondaryLang
                : response.contentPrimaryLang;
            setMessageBarData({
                ...messageBarData,
                Key: response.id,
                content: DOMPurify.sanitize(content ?? ''),
            });
            setShowMessege(messageTypeProps);
        } catch (exception) {
            setMessageBarData({
                ...messageBarData,
                content: DOMPurify.sanitize(exception.message ?? ''),
            });
            setshowMessageType(MarkDownIslandType.Errorr);
        }
    };

    useEffect(() => {
        if (
            (messageTypeProps === MarkDownType.Terms ||
                messageTypeProps === MarkDownType.RegistrationPrivacy) &&
            propsCurrentLanguage.langIso4
        ) {
            handleMessageBarData(messageTypeProps, propsCurrentLanguage);
        }
    }, [messageTypeProps, propsCurrentLanguage.lang]);

    return messageTypeProps === MarkDownType.Informative ||
        messageTypeProps === MarkDownType.Important ? (
        <MarkDownIsland
            code={messageTypeProps}
            Type={showMessageType}
            currentUser={authService.currentUser}
            messageData={messageBarData}
            onsetMessageBarData={(code: string, lang: Language) =>
                handleMessageBarData(code, lang)
            }
        />
    ) : (
        <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(messageBarData?.content ?? ''),
            }}
        />
    );
};
export default connector(MarkDown);
